﻿$.fn.dxCtrlGridTelSmsListeNoire = function custom_dxCtrlGridTelSmsListeNoire(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridtelsmslistenoire dx-ctrl");
        this.createInstance(new cdxCtrlGridTelSmsListeNoire(this, option));
    }
    return this;
}

window.cdxCtrlGridTelSmsListeNoire = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.context_grid == 'undefined') option.context_grid = "gridlistenoiregeneralsms"

    var dxGrid = null
    function mConstruit() {
        container.empty();

        container.css("height", "100%")

        var lstField = mGetLstField()
        var opt = {
            bddCtrl: option.bddCtrl,
            noDataText: "Aucun téléphone désinscrits",
            typeData: "lstlistenoiretelsms",
            lstTypeGrille: ["Lignes", "Détails"],
            getItemTemplateHeight: function (typeGrille) { return ((typeGrille == "Lignes") ? 55 : 121) },
            context_grid: option.context_grid,
            itemTemplateGrille: itemTemplateGrille,
            itemTemplateGrillePlus: itemTemplateGrillePlus,
            nomTemplateIco: "sms_liste_noire",
            itemsToolbar: mGetLstButtonToolBar(),
            onDisplayButtonLigne: mGetLstButtonLigne,
            lstLstConditionBase: option.lstLstConditionBase,
            onClickDataGrid: function (container, dataGrid, dataTemplate) {
                if (typeof dataTemplate.strcon == 'undefined') {
                    //pas de strcon, on affiche un message
                    mNotify("Ce téléphone n'est lié à aucune fiche", "warning", 3000)
                } else {
                    //on affiche le strcon
                    var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table)
                    option.bddCtrl.getObjet(table.nom, dataTemplate.strcon.id).mShowPopup()
                }
            },
            onEndClickDataGrid: option.onEndClickDataGrid,
            fields: lstField,
            allowCarto: false,
            allowFilter: true,
            allowLucene: true,
            allowCheck: false,
            allowToolbar: option.allowToolbar,
            allowDeleteInToolbar: false,
            showColumnHeaders: option.showColumnHeaders,
            lstIdTableIdExclu: option.lstIdTableIdExclu,
            lstIdTableIdInclu: option.lstIdTableIdInclu
        }

        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid(opt).dxCtrlVirtualGrid("instance")
    }

    function itemTemplateGrille(contentElement, dataTemplate, type) {
        var $Table = $("<table style='width:100%;height:100%;table-layout:fixed;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var tel = new cTelephone(dataTemplate.sms_liste_noire.tel_code_pays, dataTemplate.sms_liste_noire.tel_sms)
        var $TdAdresseEmail = $("<td style='width:30%;padding:0 3px;white-space:nowrap;'><u>" + tel.mGetValueMiseEnForme() + "</u></td>").appendTo($Tr)
        var $TdStrCon = $("<td style='width:100%;text-align:left;'/>").appendTo($Tr)

        var $TdStrCon = $("<td style='padding:0 5px;width:70%;'/>").appendTo($Tr)
        if (typeof dataTemplate.strcon == "undefined") {
            $TdStrCon.html("<span style='opacity:0.3;'>Aucune fiche pour le téléphone</span>")
        } else {
            $TdStrCon.addClass('state-hover2')
            var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table_key)
            var obj = option.bddCtrl.getObjet(table.nom)
            var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo($TdStrCon)
            var $Tr = $("<tr/>").appendTo($Table)
            var $TdICone = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
            obj.mGetIcone(dataTemplate.strcon).appendTo($TdICone)
            var $TdImage = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
            $("<div style='width:18px;height:18px;border-radius:50%;'/>").appendTo($TdImage).dxCtrlImgSimpleStrConUti({
                bddCtrl: option.bddCtrl,
                idTable: table.id_table,
                id: dataTemplate.strcon.id_key,
                dataTemplate: dataTemplate,
                text: ""
            })
            var $TdLib = $("<td style='width:100%;padding:0 3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:bold;'/>").appendTo($Tr)
            $TdLib.text(obj.objetMetier.mGetLibNomPrenomFromDataTemplate(dataTemplate.strcon))
            $TdStrCon.attr("title", "Ouvrir la fiche<br/>" + obj.objetMetier.mGetLibNomPrenomFromDataTemplate(dataTemplate.strcon))
            $TdStrCon.on("click", function (e) { e.stopPropagation(); option.bddCtrl.getObjet(table.nom, dataTemplate.strcon.id_key).mShowPopup() })
        }
    }
    function itemTemplateGrillePlus(contentElement, dataTemplate) {
        var $Span = $("<span style=''><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataTemplate.sms_liste_noire.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
        $Span.attr("title", dataTemplate.sms_liste_noire.dcr.toFrenchDateTime())
    }

    function mGetLstField() {
        var lst = []
        lst = lst.concat([{
            name: "dcr",
            dataField: "dcr",
            caption: "Date création",
            icon: "fas fa-clock",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            groupIndex: 0,
            sortOrder: "desc",
            dataType: "date",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            calculateGroupValue: function (rowData) {
                return rowData.dcr.toGrpDate().id
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Désinscription: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
            filterLinkGrp: "dcr_tri"
        }, {
            name: "dcr_tri",
            dataField: "dcr_tri",
            allowGrid: true,
            visible: false
        }, {
            name: "id_com_sms_envoi",
            dataField: "id_com_sms_envoi",
            caption: "id_com_sms_envoi",
            icon: "fas fa-clock",
            allowFilter: false,
            allowGrid: false,
            allowGrouping: false,
            allowSorting: false,
            dataType: "number"
        }])

        lst = lst.concat([{
            name: "tel_code_pays",
            dataField: "tel_code_pays",
            caption: "Code pays",
            icon: "fas fa-map",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("Code pays: " + options.displayValue + " (" + tot + ")")
            }
        }, {
            name: "tel_sms",
            dataField: "tel_sms",
            caption: "Numéro téléphone",
            icon: "fas fa-at",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: false,
            allowSorting: true,
            dataType: "string"
        }])

        return lst
    }

    function mGetLstButtonToolBar() {
        var items = []
        items.push({
            location: 'before',
            template: function (itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-bars-staggered",
                    icon2: "fas fa-ellipsis",
                    colorIcone2: theme.colorBtIcon2,
                    opacityIcone2: "0.9",
                    hint: "Afficher la grille structures/contacts des clicks",
                    onClick: function (e) {
                        var xlstIdTableId = ""
                        dxGrid.mGetLstTraitementData().forEach(function (dataGrid) {
                            xlstIdTableId += ((xlstIdTableId.length > 0) ? "," : "") + dataGrid.id
                        })
                        if (xlstIdTableId.length > 0) {
                            option.bddCtrl.mAjaxCall({ command: "getdataslsttellistenoire", lstid: xlstIdTableId }, function (data) {
                                data.lst = JSON.parse(data.lst)
                                //if (typeof data.lst == 'undefined') data.lst = []
                                if (data.lst.length > 0) {
                                    page.mAddPopupLst("Liste des désinscriptions SMS" + ((typeof option.objet == 'undefined') ? "" : " &bull; " + option.objet), function (contentElement) {
                                        $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                            bddCtrl: option.bddCtrl,
                                            lstIdTableIdInclu: data.lst
                                        })
                                    })
                                } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                            })
                        } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                    }
                }).dxCtrlButton("instance")
            }
        })
        //if (typeof option.showBtNew == 'undefined' || option.showBtNew) {
        //    items.push({
        //        location: 'before',
        //        template: function (itemData, itemIndex, itemElement) {
        //            $("<div/>").appendTo(itemElement).dxCtrlButton({
        //                icon: "fas fa-comment-sms",
        //                icon2: "fas fa-certificate",
        //                colorIcone2: theme.colorBtIcon2,
        //                opacityIcone2: "0.9",
        //                txtTooltip: "Nouveau SMS",
        //                onClick: function (e) {
        //                    option.bddCtrl.getObjet("com_sms_envoi").objetMetier.mShowNewSms()
        //                }
        //            }).dxCtrlButton("instance")
        //        }
        //    })
        //}
        return items
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {

    }

    this.mChangeLstIdTableIdExclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdExclu(lstId)
    }
    this.mChangeLstIdTableIdInclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdInclu(lstId)
    }

    this.element = function () { return container }

    mConstruit();
}